module.exports = __webpack_public_path__ + "img/sitemap-outline.svg";